// @ts-strict-ignore
import {apiClient} from 'common/util/api-client';
import {
  BehaviorEntity as Behavior,
  BehaviorsRequest,
  BehaviorsResponse,
  BehaviorsResultsMap,
} from 'app_api/projects/behaviors/types';
import {ApiResourceClient} from 'common/util/model-resource/api-resource';
import {getProjectId} from 'common/report/util';
import {reporter} from 'common/report/error-reporting';

import {appApiUrl} from '../utils';
import {purgeFetchCache} from '../utils/fetch-cache';

function buildEndpoint({behaviorId = null}: {behaviorId?: string} = {}): string {
  return appApiUrl(`behaviors` + (behaviorId ? `/${behaviorId}` : ``), {projectId: getProjectId()});
}

export async function createBehavior(behaviorsRequest: BehaviorsRequest): Promise<BehaviorsResultsMap> {
  try {
    return await apiClient.post<BehaviorsResultsMap>(buildEndpoint(), behaviorsRequest);
  } catch (error) {
    reporter.error(error, `createBehavior error`, {behaviorsRequest});
    throw error;
  }
}

export async function updateBehavior({
  behaviorId,
  behavior,
}: {
  behaviorId: string;
  behavior: Partial<Behavior>;
}): Promise<BehaviorsResultsMap> {
  try {
    return await apiClient.patch<BehaviorsResultsMap>(buildEndpoint({behaviorId}), behavior);
  } catch (error) {
    reporter.error(error, `updateBehavior error`, {behaviorId, behavior});
    throw error;
  }
}

export async function deleteBehavior(behavior: Behavior): Promise<BehaviorsResultsMap> {
  try {
    return await apiClient.delete<BehaviorsResultsMap>(buildEndpoint(), {
      body: JSON.stringify({behaviors: [behavior]}),
    });
  } catch (error) {
    reporter.error(error, `deleteBehaviors error`, {behavior});
    throw error;
  }
}

export async function bulkUpdateBehaviors(behaviors: Array<Partial<Behavior>>): Promise<BehaviorsResultsMap> {
  try {
    return await apiClient.patch<BehaviorsResultsMap>(buildEndpoint(), {behaviors});
  } catch (error) {
    reporter.error(error, `bulkUpdateBehaviors error`, {behaviors});
    throw error;
  }
}

export const behaviorsClient: ApiResourceClient<TODO> = {
  index() {
    return apiClient.hydratedGet<BehaviorsResponse>(buildEndpoint());
  },

  get(behaviorId: string) {
    return apiClient.hydratedGet<BehaviorsResponse>(buildEndpoint({behaviorId}));
  },

  purgeCache() {
    purgeFetchCache({everything: true, path: buildEndpoint()});
  },
};
